import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Chat from './Chat';
import { seekerDataService } from '../../services/seekerDataService';
import { type Guide } from '../../types';

export const HomeChatView: React.FC = () => {
  const navigate = useNavigate();
  const [guide, setGuide] = useState<Guide | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    const loadGuide = async () => {
      try {
        setLoading(true);
        const data = await seekerDataService.getHomePageData();
        if (!isMounted) return;
        setGuide(data.match?.guide_details ?? null);
        setError(null);
      } catch (err) {
        if (!isMounted) return;
        console.error('Failed to load guide details for chat view', err);
        const message = err instanceof Error ? err.message : 'Unable to load guide details.';
        setError(message);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadGuide();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleBack = () => {
    navigate('/home');
  };

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mx-auto mb-4 h-12 w-12 animate-spin rounded-full border-b-2 border-gray-900" />
          <p className="text-gray-600">Loading chat...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-gray-50 px-4">
        <div className="max-w-sm text-center">
          <p className="mb-4 text-sm text-red-600">{error}</p>
          <button
            type="button"
            onClick={handleBack}
            className="rounded bg-gray-900 px-4 py-2 text-sm font-medium text-white hover:bg-gray-800"
          >
            Back to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <Chat
      onBack={handleBack}
      guide={guide ? {
        id: guide.id,
        name: guide.name,
        image: guide.image ?? null,
        status: 'Online now'
      } : null}
    />
  );
};

export default HomeChatView;
